import React, { useEffect, useRef, useState } from "react";
import AnimatedContent from "./AnimatedContent";

const Drawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const drawerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDrawerOpen = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div ref={drawerRef}>
      <div className="contact" onClick={handleDrawerOpen}>
        CONTACT
      </div>
      {isOpen && (
        <AnimatedContent side="right">
          <div className="popup">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 10
                }}>
                <div>Phone</div>
                <a href="tel:+919136716457" style={{ color: "#85b9ff", textDecoration: "none" }}>
                  +91 9136716457
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 10
                }}>
                <div>Email</div>
                <a href="mailto:ask@starnex.co" style={{ color: "#85b9ff" }}>
                  ask@starnex.co
                </a>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: 10
                }}>
                <div>Instagram</div>
                <a
                  href="https://www.instagram.com/starnex.in?igsh=MW12NzVpeTRsZDJlaw%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#85b9ff", textDecoration: "none" }}>
                  @starnex.in
                </a>
              </div>
            </div>
          </div>
        </AnimatedContent>
      )}
    </div>
  );
};

export default Drawer;
